(function () {

	const footerOnyra = () => {
		const footerDetails = document.querySelectorAll(
			'.footer-onyra .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footerOnyra);
	footerOnyra();

})();
